import React, { useEffect, useRef, useState } from "react";
import { gantt } from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import Select from "react-select";
import { Button, Spinner, Collapse } from "reactstrap";
import Swal from "sweetalert2";
import swal from "@sweetalert/with-react";
import "./myReactSelect.css";
import { AppSwitch } from "@coreui/react";

import axios from "axios";
import { baseurl } from "../../../baseurl";
import Responseloader from "./ResponseLoader";
import { roundDecimalNumber } from "../../../utils/functions";
import { checkPermission } from "../../../Helper";
const moment = require("moment");
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");
let companyId = localStorage.getItem("companyId");
// Add this at the top of your file
const today = moment().startOf("day");

const SimpleSelect = () => {
  // values
  var global_status = [];
  var departmentNames = [];
  const [sheet, setSheet] = useState([]);
  const [department, setDepartment] = useState([]);
  const [plan, setPlan] = useState([]);
  const [article, setArticle] = useState([]);

  const [category, setCategory] = useState([]);
  const [styles, setStyles] = useState([]);
  const [priority, setPriority] = useState([]);
  const [skuColor, setSkuColor] = useState([]);
  const [status, setStatusLov] = useState([]);

  const [categoryLov, setCategoryLov] = useState([]);
  const [stylesLov, setStylesLov] = useState([]);
  const [priorityLov, setPriorityLov] = useState([]);
  const [skuColorLov, setSkuColorLov] = useState([]);
  // State to hold chart data
  const [chartData, setChartData] = useState(null);
  const [taskArr, setTaskArr] = useState([]);
  // lovs
  const [sheetLov, setSheetLov] = useState([]);
  const [departmentLov, setDepartmentLov] = useState([]);
  const [planLov, setPlanLov] = useState([]);
  const [articleLov, setArticleLov] = useState([]);
  const [updatedArray, setUpdatedArray] = useState([]);
  const [saveExpanded, setSaveExpanded] = useState([]);

  const [loadingResponce, setLoadingResponce] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [collapseCriteria, setCollapseCriteria] = useState(false);
  const [counter, setCounter] = useState(false);
  const [showBtn, setShowBtn] = useState(false);

  const ganttContainer = useRef(null);
  // let counter = 0;
  const findSmallestDate = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);

    if (momentDate1.isBefore(momentDate2)) {
      return momentDate1;
    } else {
      return momentDate2;
    }
  };
  const callFuncDb = async () => {
    try {
      setIsLoading(true);
      const res = await axios.post(
        `${baseurl}/department/runGanttProcess`,
        {
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );
    } catch (error) {
      console.error("Error in callFuncDb:", error);
      swal({
        title: "Error",
        text: "An error occurred while fetching data.",
        icon: "error",
        button: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getData = async () => {
    // setLoadingResponce(true);
    setIsLoading(true);

    const generateIdsString = (array) =>
      `(${array.map((item) => item.id).join(", ")})`;

    const deptIds = generateIdsString(department);
    const planIds = generateIdsString(plan);
    const sheetIds = generateIdsString(sheet);
    const articleIds = generateIdsString(article);
    const categoryIds = generateIdsString(category);
    const stylesIds = generateIdsString(styles);
    const priorityIds = generateIdsString(priority);
    const skuColorIds = generateIdsString(skuColor);
    try {
      const res = await axios.post(
        `${baseurl}/department/getGanttDataFuture`,
        {
          departments: department.length > 0 ? deptIds : null,
          plans: plan.length > 0 ? planIds : null,
          sheets: sheet.length > 0 ? sheetIds : null,
          articles: article.length > 0 ? articleIds : null,
          categories: category.length > 0 ? categoryIds : null,
          styles: styles.length > 0 ? stylesIds : null,
          priority: priority.length > 0 ? priorityIds : null,
          sku_color: skuColor.length > 0 ? skuColorIds : null,
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );

      setIsLoading(false);
      const DATE_FORMAT_DISPLAY = "DD-MM-YYYY";
      const DATE_FORMAT_INTERNAL = "YYYY-MM-DD";

      const departments = {};
      const tasks = [];
      let idCounter = 1;
      let minimuimStartDate = null;
      let dynamicDepartCounter = 0;

      const formatDate = (date, format) => moment(date).format(format);

      const roundDecimalNumber = ({ number, decimal }) =>
        parseFloat(number.toFixed(decimal));

      const calculateProgress = (qty, remaining) =>
        roundDecimalNumber({
          number: (qty - remaining) / qty,
          decimal: 2,
        });

      const calculateReqOutput = (tot_rem_qty, days_req) =>
        roundDecimalNumber({
          number: tot_rem_qty / (days_req === 0 ? 1 : days_req),
          decimal: 2,
        });

      const createDepartment = (item) => ({
        id: idCounter++,
        text: item.DEPARTMENT,
        label: item.DEPARTMENT,
        start_date: formatDate(item.START_DATE, DATE_FORMAT_DISPLAY),
        deadline: formatDate(moment(), DATE_FORMAT_INTERNAL),
        ordQty: 0,
        days: 0,
        tot_rem_qty: 0,
        days_req: 0,
        worker: 0,
        det_workers: 0,
        req_output: 0,
        duration: 0,
        progress: 0,
        parent: null,
        plans: {}, // Object to store plans within the department
        department_label: item.DEPARTMENT, // Add department label
        department_id: dynamicDepartCounter,
        customer: item.customer || "a", // Add customer
        order_no: item.order_no || 555, // Add order number
        order_item_desc: item.order_item_desc, // Add order number
        order_color: item.order_color, // Add order number
      });

      const createPlan = (item, departmentId) => ({
        id: idCounter++,
        label: item.PLAN_DESC,
        text: item.PLAN_DESC,
        start_date: formatDate(item.START_DATE_PLAN, DATE_FORMAT_DISPLAY),
        deadline: formatDate(moment(), DATE_FORMAT_INTERNAL),
        ordQty: 0,
        days: 0,
        tot_rem_qty: item.TOT_REM_QTY,
        days_req: 0,
        worker: 0,
        det_workers: item.det_workers,
        req_output: 0,
        duration: 0,
        progress: 0,
        parent: departmentId,
        department_label: item.DEPARTMENT, // Add department label
        TOT_DAYS: item.TOT_DAYS,
        department_id: dynamicDepartCounter,
        customer: item.customer || "a", // Add customer
        order_no: item.order_no || 555, // Add order number
        order_item_desc: item.order_item_desc, // Add order number
        order_color: item.order_color, // Add order number
      });

      const createItem = (item, planId) => ({
        id: idCounter++,
        label: item.ITEM_DESC,
        text: item.ITEM_DESC,
        start_date: formatDate(item.START_DATE, DATE_FORMAT_DISPLAY),
        ordQty: item.ORDER_QTY,
        sam: item.SAM,
        days: roundDecimalNumber({
          number: item.DAYS / (item.det_workers > 0 ? item.det_workers : 1),
          decimal: 2,
        }),
        tot_rem_qty: item.REMAINING,
        days_req: roundDecimalNumber({
          number:
            item.REMAINING_DAYS / (item.det_workers > 0 ? item.det_workers : 1),
          decimal: 2,
        }),
        duration: Math.ceil(item.DAYS),
        deadline: formatDate(moment(), DATE_FORMAT_INTERNAL),
        progress: calculateProgress(item.ORDER_QTY, item.REMAINING),
        det_workers: item.det_workers,
        parent: planId,
        department_label: item.DEPARTMENT, // Add department label
        department_id: dynamicDepartCounter,
        editable: true,
        oneOrderId: item.one_order_id,
        req_output: calculateReqOutput(
          item.REMAINING,
          item.REMAINING_DAYS / (item.det_workers > 0 ? item.det_workers : 1)
        ),
        customer: item.customer || "a", // Add customer
        order_no: item.order_no || 555, // Add order number
        order_item_desc: item.order_item_desc, // Add order number
        order_color: item.order_color, // Add order number
      });
      const processData = (data) => {
        data.forEach((item) => {
          if (!departments[item.DEPARTMENT]) {
            dynamicDepartCounter++;
            departments[item.DEPARTMENT] = createDepartment(item);
            minimuimStartDate = findSmallestDate(
              minimuimStartDate,
              item.START_DATE
            );
            tasks.push(departments[item.DEPARTMENT]);

            if (!departmentNames.includes(departments[item.DEPARTMENT].label)) {
              departmentNames = [
                ...departmentNames,
                departments[item.DEPARTMENT].label,
              ];
            }
          }

          if (!departments[item.DEPARTMENT].plans[item.PLAN_DESC]) {
            departments[item.DEPARTMENT].plans[item.PLAN_DESC] = createPlan(
              item,
              departments[item.DEPARTMENT].id
            );
            minimuimStartDate = findSmallestDate(
              minimuimStartDate,
              item.START_DATE_PLAN
            );
            tasks.push(departments[item.DEPARTMENT].plans[item.PLAN_DESC]);

            // Initialize plan total remaining quantity to 0
            departments[item.DEPARTMENT].plans[item.PLAN_DESC].tot_rem_qty = 0;
          }

          const planItem = createItem(
            item,
            departments[item.DEPARTMENT].plans[item.PLAN_DESC].id
          );
          tasks.push(planItem);

          // Aggregate order qty and days at department & plan level
          departments[item.DEPARTMENT].ordQty += item.ORDER_QTY;
          departments[item.DEPARTMENT].days += item.TOT_DAYS;

          departments[item.DEPARTMENT].plans[item.PLAN_DESC].ordQty +=
            item.ORDER_QTY;
          departments[item.DEPARTMENT].plans[item.PLAN_DESC].det_workers +=
            item.det_workers;

          // Sum item.REMAINING to plan totals (this is the only place it gets added)
          departments[item.DEPARTMENT].plans[item.PLAN_DESC].tot_rem_qty +=
            item.REMAINING;

          departments[item.DEPARTMENT].plans[item.PLAN_DESC].days_req =
            item.DAYS_REQ;
        });
      };
      // const processData = (data) => {
      //   data.forEach((item) => {
      //     if (!departments[item.DEPARTMENT]) {
      //       dynamicDepartCounter++;
      //       departments[item.DEPARTMENT] = createDepartment(item);
      //       minimuimStartDate = findSmallestDate(
      //         minimuimStartDate,
      //         item.START_DATE
      //       );
      //       tasks.push(departments[item.DEPARTMENT]);
      //       // Ensure unique department names
      //       if (!departmentNames.includes(departments[item.DEPARTMENT].label)) {
      //         departmentNames = [
      //           ...departmentNames,
      //           departments[item.DEPARTMENT].label,
      //         ];
      //       }
      //     }

      //     if (!departments[item.DEPARTMENT].plans[item.PLAN_DESC]) {
      //       departments[item.DEPARTMENT].plans[item.PLAN_DESC] = createPlan(
      //         item,
      //         departments[item.DEPARTMENT].id
      //       );
      //       minimuimStartDate = findSmallestDate(
      //         minimuimStartDate,
      //         item.START_DATE_PLAN
      //       );
      //       tasks.push(departments[item.DEPARTMENT].plans[item.PLAN_DESC]);
      //     }

      //     const planItem = createItem(
      //       item,
      //       departments[item.DEPARTMENT].plans[item.PLAN_DESC].id
      //     );
      //     tasks.push(planItem);

      //     departments[item.DEPARTMENT].ordQty += item.ORDER_QTY;
      //     departments[item.DEPARTMENT].days += item.TOT_DAYS;
      //     // departments[item.DEPARTMENT].tot_rem_qty += item.TOT_REM_QTY;
      //     departments[item.DEPARTMENT].plans[item.PLAN_DESC].ordQty +=
      //       item.ORDER_QTY;
      //     departments[item.DEPARTMENT].plans[item.PLAN_DESC].det_workers +=
      //       item.det_workers;
      //     // departments[item.DEPARTMENT].plans[item.PLAN_DESC].tot_rem_qty =
      //     //   item.TOT_REM_QTY;
      //     departments[item.DEPARTMENT].plans[item.PLAN_DESC].tot_rem_qty =
      //       (departments[item.DEPARTMENT].plans[item.PLAN_DESC].tot_rem_qty ||
      //         0) + item.REMAINING;

      //     departments[item.DEPARTMENT].plans[item.PLAN_DESC].days_req =
      //       item.DAYS_REQ;
      //   });
      // };

      const sumPlanDaysAndDaysReq = () => {
        Object.values(departments).forEach((department) => {
          Object.values(department.plans).forEach((plan) => {
            let planDaysSum = 0;
            let planDaysReqSum = 0;
            tasks.forEach((task) => {
              if (task.parent === plan.id) {
                planDaysSum += task.days;
                planDaysReqSum += task.days_req;
              }
            });
            plan.days = roundDecimalNumber({ number: planDaysSum, decimal: 2 });
            plan.days_req = roundDecimalNumber({
              number: planDaysReqSum,
              decimal: 2,
            });
          });
        });
      };

      // const updateDepartmentAndPlanTasks = () => {
      //   Object.values(departments).forEach((department) => {
      //     let sumOfDays = 0;
      //     let sumOfReqDays = 0;
      //     let sumOfRemQty = 0;
      //     let sumOfDet_workers = 0;

      //     Object.values(department.plans).forEach((plan) => {
      //       sumOfDays += plan.days;
      //       sumOfReqDays += plan.days_req;
      //       sumOfRemQty += plan.tot_rem_qty;
      //       sumOfDet_workers += plan.det_workers;

      //       plan.duration = Math.ceil(plan.days);
      //       plan.progress = calculateProgress(plan.ordQty, plan.tot_rem_qty);
      //       plan.req_output = calculateReqOutput(
      //         plan.tot_rem_qty,
      //         plan.days_req
      //       );
      //       plan.start_date = formatDate(
      //         minimuimStartDate,
      //         DATE_FORMAT_DISPLAY
      //       );
      //     });

      //     department.days = roundDecimalNumber({
      //       number: sumOfDays,
      //       decimal: 2,
      //     });
      //     department.days_req = roundDecimalNumber({
      //       number: sumOfReqDays,
      //       decimal: 2,
      //     });
      //     department.start_date = formatDate(
      //       minimuimStartDate,
      //       DATE_FORMAT_DISPLAY
      //     );
      //     department.tot_rem_qty = roundDecimalNumber({
      //       number: sumOfRemQty,
      //       decimal: 2,
      //     });
      //     department.req_output = roundDecimalNumber({
      //       number: sumOfRemQty / sumOfReqDays,
      //       decimal: 2,
      //     });
      //     department.duration = Math.ceil(department.days);
      //     department.progress = calculateProgress(
      //       department.ordQty,
      //       sumOfRemQty
      //     );
      //     department.det_workers = sumOfDet_workers;
      //   });
      // };

      const updateDepartmentAndPlanTasks = () => {
        Object.values(departments).forEach((department) => {
          let sumOfDays = 0;
          let sumOfReqDays = 0;
          let sumOfRemQty = 0;
          let sumOfDet_workers = 0;

          Object.values(department.plans).forEach((plan) => {
            sumOfDays += plan.days;
            sumOfReqDays += plan.days_req;
            sumOfRemQty += plan.tot_rem_qty; // now safe: no duplicates
            sumOfDet_workers += plan.det_workers;

            plan.duration = Math.ceil(plan.days);
            plan.progress = calculateProgress(plan.ordQty, plan.tot_rem_qty);
            plan.req_output = calculateReqOutput(
              plan.tot_rem_qty,
              plan.days_req
            );
            plan.start_date = formatDate(
              minimuimStartDate,
              DATE_FORMAT_DISPLAY
            );
          });

          department.days = roundDecimalNumber({
            number: sumOfDays,
            decimal: 2,
          });
          department.days_req = roundDecimalNumber({
            number: sumOfReqDays,
            decimal: 2,
          });
          department.start_date = formatDate(
            minimuimStartDate,
            DATE_FORMAT_DISPLAY
          );
          department.tot_rem_qty = roundDecimalNumber({
            number: sumOfRemQty,
            decimal: 2,
          });
          department.req_output = roundDecimalNumber({
            number: sumOfRemQty / (sumOfReqDays === 0 ? 1 : sumOfReqDays),
            decimal: 2,
          });
          department.duration = Math.ceil(department.days);
          department.progress = calculateProgress(
            department.ordQty,
            sumOfRemQty
          );
          department.det_workers = sumOfDet_workers;
        });
      };
      // processData(res.data.data);
      // sumPlanDaysAndDaysReq();
      // updateDepartmentAndPlanTasks();
      if (Array.isArray(res.data.data) && res.data.data.length > 0) {
        processData(res.data.data);
        sumPlanDaysAndDaysReq();
        updateDepartmentAndPlanTasks();
        const deepCopyArray = JSON.parse(JSON.stringify(tasks));
        setTaskArr(deepCopyArray);

        const links = []; // Define links array if needed

        setChartData({ tasks, links });
      } else {
        setTaskArr([]);
        setChartData({ tasks: [], links: [] });
        return;
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      // Handle error
    }
  };
  // Function to generate colors based on department ID
  const generateColor = (id) => {
    const colors = [
      "#0000FF",
      "#00008B",
      "#8A2BE2",
      "#4B0082",
      "#FF0000",
      "#8B0000",
      "#FF4500",
      "#008000",
      "#FFFF00",
      "#FF69B4",
    ];
    return colors[id % colors.length]; // Get color based on ID
  };
  const calculateExtendedDuration = (task) => {
    const today = moment().startOf("day");
    const startDate = moment(task.start_date, "DD-MM-YYYY");
    const originalDuration = task.duration;
    const originalEndDate = startDate.clone().add(originalDuration, "days");
    const isCompleted = task.progress >= 1;

    // Extend only if task is not completed and req_days > 1
    if (!isCompleted && task.days_req > 1 && originalEndDate.isBefore(today)) {
      const daysPassed = today.diff(originalEndDate, "days");
      return originalDuration + daysPassed;
    }

    return originalDuration;
  };

  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(0);
    const fetchData = async () => {
      try {
        await getLovs(1); // Fetch lov data
        // await getData(); // Fetch gantt chart data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/ganttChart";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };

  useEffect(() => {
    // if (!chartData?.tasks) return;
    if (!chartData?.tasks || chartData.tasks.length === 0) return; //

    // 1) Clear & basic config
    gantt.clearAll();
    gantt.config.xml_date = "%d-%m-%Y";
    gantt.config.min_column_width = 50;
    gantt.config.task_height = 40;
    gantt.config.task_bar_height = 15;
    gantt.config.scale_height = 50;
    gantt.config.grid_width = 300;
    gantt.plugins({ tooltip: true });

    // 2) Dynamic date window
    const dates = chartData.tasks.map((t) =>
      moment(t.start_date, "DD-MM-YYYY").toDate()
    );
    const minStart = new Date(Math.min(...dates));
    gantt.config.start_date = gantt.date.add(minStart, -2, "day");
    const maxEnd = chartData.tasks.reduce((mx, t) => {
      const od = moment(t.start_date, "DD-MM-YYYY")
        .clone()
        .add(t.duration, "days");
      return od.isAfter(mx) ? od : mx;
    }, moment(minStart));
    gantt.config.end_date = gantt.date.add(maxEnd.toDate(), 5, "day");

    // 3) Grid columns (show original durations)
    gantt.config.columns = [
      { name: "label", label: "Description", tree: true, width: 200 },
      {
        name: "start_date",
        label: "StrtDte",
        align: "center",
        width: 80,
        editor: { type: "date", map_to: "start_date" },
        template: (t) => moment(t.start_date).format("MMM-D"),
      },
      {
        name: "_originalDuration",
        label: "Days",
        align: "center",
        width: 60,
        template: (t) => t._originalDuration ?? t.duration,
      },
      { name: "ordQty", label: "Ord.Qty", align: "center", width: 60 },
      { name: "sam", label: "SAM", align: "center", width: 60 },
      { name: "tot_rem_qty", label: "RemQty", align: "center", width: 60 },
      { name: "days_req", label: "DayReq", align: "center", width: 60 },
      {
        name: "det_workers",
        label: "Wkrs",
        align: "center",
        width: 60,
        editor: { type: "number", map_to: "det_workers", min: 0, max: 100 },
      },
      {
        name: "req_output",
        label: "ReqOpt",
        align: "center",
        width: 60,
        editor: false,
      },
    ];

    // 4) Department → CSS class map
    const departmentClasses = {
      Cutting: "department-1",
      Stitches: "department-2",
      Stitching: "department-2",
      "Info Pending": "department-3",
      Procuremnet: "department-4",
      "Procurement Ready": "department-5",
      "Cutting Ready": "department-6",
      Adda: "department-7",
      "Adda Ready": "department-8",
      Patches: "department-9",
      "Patches Ready": "department-10",
      "Stitching Ready": "department-11",
      "Stitches Ready": "department-11",
      Specs: "department-12",
      "Specs Ready": "department-13",
      Embroidery: "department-14",
      "Embroidery Ready": "department-15",
      Quality: "department-16",
      "Quality Ready": "department-17",
      Shipped: "department-18",
    };

    // 5) Extend bar length by remaining days_req when overdue
    const calculateExtendedDuration = (task) => {
      const today = moment().startOf("day");
      const startDate = moment(task.start_date, "DD-MM-YYYY");
      const origDur = task.duration;
      const origEnd = startDate.clone().add(origDur, "days");
      const hasStarted = today.isAfter(startDate, "day");
      const isDone = task.progress >= 1;

      if (
        hasStarted &&
        !isDone &&
        task.days_req > 0 &&
        origEnd.isBefore(today)
      ) {
        const usedDays = today.diff(startDate, "days");
        return usedDays + task.days_req;
      }
      return origDur;
    };

    // 6) Build tasks for timeline: override duration & progress
    const transformed = chartData.tasks.map((t) => {
      const origDur = t.duration;
      const extDur = calculateExtendedDuration(t);
      const startDate = moment(t.start_date, "DD-MM-YYYY");
      const today = moment().startOf("day");
      const usedDays = today.isAfter(startDate, "day")
        ? Math.min(extDur, today.diff(startDate, "days"))
        : 0;
      const newProg = extDur > 0 ? Math.min(1, usedDays / extDur) : t.progress;

      return {
        ...t,
        _originalDuration: origDur,
        duration: extDur,
        progress: newProg,
        text: t.label,
      };
    });

    // 7) task_class: department + optional extended outline
    gantt.templates.task_class = (start, end, task) => {
      const deptClass = departmentClasses[task.department_label] || "";
      const extended =
        task.duration > task._originalDuration ? " extended-task" : "";
      return deptClass + extended;
    };

    // 8) Inject dashed-outline CSS once
    if (!document.getElementById("gantt-extended-css")) {
      const css = document.createElement("style");
      css.id = "gantt-extended-css";
      css.innerHTML = `
      .extended-task .gantt_task_content {
        border: 2px dashed #1976D2 !important;
      }
    `;
      document.head.appendChild(css);
    }

    // 9) Initialize & render
    console.log(ganttContainer.current);
    console.log(transformed);

    gantt.init(ganttContainer.current);
    gantt.parse({ data: transformed, links: chartData.links });
  }, [chartData]);

  const Toggle = async () => {
    setCollapseCriteria(!collapseCriteria);
    if (!collapseCriteria && !counter) {
      setCounter(true);

      await getLovs(2);
    }
  };
  const getLovs = async (dynamicCheck) => {
    // setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/pointOfSale/getLovsData`,
        {
          companyId: companyId,
          username: username,
          check: dynamicCheck, //1= regular tables , 2= extended tables
          tables:
            dynamicCheck === 1
              ? ["sheetType", "department", "plan", "item", "status"]
              : ["skuColor", "priority", "category", "style"],
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        // setLoadingResponce(false);
        const responseData = response.data;
        let {
          sheetType,
          plan,
          department,
          item,
          category,
          priority,
          skuColor,
          style,
          status,
        } = responseData;

        const newObj = { id: -1, label: "All" };
        if (dynamicCheck === 1) {
          //---------- Standdard Criteria --------------
          // Update the state by pushing newObj to the beginning of each array
          console.log("get dataa=status", status);
          setPlanLov([newObj, ...plan]);
          setDepartmentLov([newObj, ...department]);
          setSheetLov([newObj, ...sheetType]);
          setArticleLov([newObj, ...item]);
          setStatusLov([newObj, ...status]);
          global_status = [...status];
        } else if (dynamicCheck === 2) {
          // -------- extended Criteria --------
          setCategoryLov([newObj, ...category]);
          setStylesLov([newObj, ...style]);
          setPriorityLov([newObj, ...priority]);
          setSkuColorLov([newObj, ...skuColor]);
        } else {
          console.log("wrong dynamicCheck");
        }
      })
      .catch((err) => {
        // setLoadingResponce(false);
        console.log(err);
      });
  };
  const masterInputEvent = (e, pName) => {
    const stateSetters = {
      department: setDepartment,
      plan: setPlan,
      sheet: setSheet,
      article: setArticle,
      category: setCategory,
      styles: setStyles,
      priority: setPriority,
      skuColor: setSkuColor,
    };

    if (pName in stateSetters) {
      const setter = stateSetters[pName];

      if (!e) {
        setter(null);
      } else if (e[e.length - 1]?.id === -1) {
        setter(null);
      } else {
        setter(e);
      }
    }
  };

  const showConfirmationModal = (check) => {
    const update = "You want to save this!";
    const cancel = `You won't be able to revert this!`;

    Swal.fire({
      title: "Are you sure?",
      text: check ? update : cancel,
      icon: check ? "question" : "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: check ? "Yes, Update it!" : "Yes, Revert it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (check) {
          updateGantt();
        } else {
          console.log("jack", taskArr);
          setShowBtn(false);
          setUpdatedArray([]);
          const links = []; // Define links array if needed
          // setChartData({ taskArr, links }); // Set chart data

          getData();
        }
      }
    });
  };
  // Function to get IDs of currently expanded tasks
  function getExpandedTasks() {
    const expandedTasks = [];
    gantt.eachTask(function (task) {
      if (task.$open) {
        expandedTasks.push(task.id);
      }
    });
    return expandedTasks;
  }

  // Function to re-expand tasks
  function expandTasks(taskIds) {
    taskIds.forEach(function (taskId) {
      gantt.open(taskId);
    });
  }
  const updateGantt = (gantArr) => {
    // setLoadingResponse(true);
    const expandedTasks = getExpandedTasks();
    setSaveExpanded(expandedTasks);
    axios
      .post(
        `${baseurl}/department/updateGantt`,
        {
          detailArray: gantArr, //updatedArray,
          username: username,
          companyId: companyId,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        // setLoadingResponse(false);

        swal({
          title: "Success!",
          text: "Gantt Chart Updated!",
          icon: "success",
        }).then((value) => {
          getData();
          // setShowBtn(false);
          setUpdatedArray([]);
        });
      })
      .catch((err) => {
        console.log(err);
        // setLoadingResponse(false);
        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
      });
  };

  return (
    <>
      {loadingResponce ? (
        <Responseloader />
      ) : (
        <div className="container-fluid bg-white">
          <div
            className="row"
            style={{
              fontSize: "12px",
            }}
          >
            <div className="col-md-2 h3 p-3" style={{ marginRight: "-1.5rem" }}>
              {" "}
              Gantt Chart{" "}
            </div>
            <div
              className="col-md-2"
              style={{
                marginTop: "0.75rem",
              }}
            >
              <Select
                onChange={(e) => masterInputEvent(e, "sheet")}
                value={sheet}
                options={sheetLov}
                id="sheet"
                name="sheet"
                required
                isMulti
                isClearable
                placeholder={"All Sheets"}
              />
            </div>
            <div
              className="col-md-2"
              style={{
                marginTop: "0.75rem",
              }}
            >
              <Select
                onChange={(e) => masterInputEvent(e, "department")}
                value={department}
                options={departmentLov}
                id="department"
                name="department"
                required
                isMulti
                isClearable
                placeholder={"All Departments"}
              />
            </div>
            <div
              className="col-md-2"
              style={{
                marginTop: "0.75rem",
              }}
            >
              <Select
                options={planLov}
                onChange={(e) => masterInputEvent(e, "plan")}
                value={plan}
                id="plan"
                name="plan"
                required
                isMulti
                placeholder={"All Plans"}
              />
            </div>
            <div
              className="col-md-2"
              style={{
                marginTop: "0.75rem",
              }}
            >
              <Select
                options={articleLov}
                onChange={(e) => masterInputEvent(e, "article")}
                value={article}
                id="article"
                name="article"
                required
                isMulti
                placeholder={"All Articles"}
              />
            </div>
            {/* {console.log("log>>>", updatedArray)} */}
            {showBtn ? (
              <>
                <div
                  className="col-md-1"
                  style={{
                    marginTop: "0.75rem",
                  }}
                >
                  <Button
                    type="submit"
                    onClick={() => showConfirmationModal(true)}
                    size="md"
                    // disabled={isLoading}
                    color="success"
                    className="mr-2" // Add some margin to separate the Button and AppSwitch
                  >
                    Update
                  </Button>
                </div>
                <div
                  className="col-md-1"
                  style={{
                    marginTop: "0.75rem",
                  }}
                >
                  <Button
                    type="submit"
                    onClick={() => showConfirmationModal(false)}
                    size="md"
                    // disabled={isLoading}
                    color="secondary"
                    className="mr-2" // Add some margin to separate the Button and AppSwitch
                  >
                    Cancel
                  </Button>
                </div>
              </>
            ) : (
              <div
                className="d-flex align-items-center"
                style={{
                  marginTop: "-0.5rem",
                }}
              >
                <Button
                  type="submit"
                  onClick={getData}
                  size="md"
                  disabled={isLoading}
                  color="success"
                  className="mr-2"
                >
                  {isLoading ? <Spinner size="sm" color="light" /> : "Find"}
                </Button>

                <AppSwitch
                  className="mr-2"
                  onClick={Toggle}
                  variant="pill"
                  size="sm"
                  color="primary"
                  label={collapseCriteria ? "Hide Criteria" : "Show Criteria"}
                  checked={collapseCriteria}
                />

                <Button
                  type="submit"
                  onClick={callFuncDb}
                  size="md"
                  disabled={isLoading}
                  color="danger" // change color here
                  className="ml-auto" // pushes this button to the far right
                >
                  {isLoading ? (
                    <Spinner size="sm" color="light" />
                  ) : (
                    "Run Process"
                  )}
                </Button>
              </div>
            )}
          </div>
          <Collapse isOpen={collapseCriteria}>
            <div
              className="d-flex flex-row "
              style={{
                fontSize: "12px",
              }}
            >
              <div
                className="col-md-3"
                style={{
                  marginTop: "0.75rem",
                  marginBottom: "1rem",
                }}
              >
                <Select
                  options={categoryLov}
                  onChange={(e) => masterInputEvent(e, "category")}
                  value={category}
                  id="category"
                  name="category"
                  required
                  isMulti
                  placeholder={"All Categories"}
                />
              </div>
              <div
                className="col-md-3"
                style={{
                  marginTop: "0.75rem",
                }}
              >
                <Select
                  options={stylesLov}
                  onChange={(e) => masterInputEvent(e, "styles")}
                  value={styles}
                  id="styles"
                  name="styles"
                  required
                  isMulti
                  placeholder={"All Styles"}
                />
              </div>

              <div
                className="col-md-3"
                style={{
                  marginTop: "0.75rem",
                }}
              >
                <Select
                  options={skuColorLov}
                  onChange={(e) => masterInputEvent(e, "skuColor")}
                  value={skuColor}
                  id="skuColor"
                  name="skuColor"
                  required
                  isMulti
                  placeholder={"All SKU Colors"}
                />
              </div>

              <div
                className="col-md-3"
                style={{
                  marginTop: "0.75rem",
                }}
              >
                <Select
                  options={priorityLov}
                  onChange={(e) => masterInputEvent(e, "priority")}
                  value={priority}
                  id="priority"
                  name="priority"
                  required
                  isMulti
                  placeholder={"All priority"}
                />
              </div>
            </div>
          </Collapse>

          <div
            ref={ganttContainer}
            style={{ width: "100%", height: "70vh" }}
          ></div>
        </div>
      )}
    </>
  );
};

export default SimpleSelect;
